import React, {useState, useContext} from 'react'; 
import UserContext  from '../../context/Globales/UserContext';
import {makeStyles, TableContainer, Table, TableCell, TableRow,TableHead,TableBody, Button, Grid, Modal, Fade, Backdrop} from '@material-ui/core';
    import {v4 as uuid } from 'uuid';

import IcpdfPropiedadesModal from '../pdf/IC/IcpdfPropiedadesModal';


    const useStyles = makeStyles((theme) => ({ 
        tituloTable: {
    
            backgroundColor: '#e6e6e6', 
           minWidth: 200,
           color: 'black',
           textAlign: 'center',
           padding: '10px',
           fontWeight: '250',
           fontSize : '16px'
        },  
        TituloIdentificacion: {
    
           backgroundColor: theme.palette.primary.main, 
           minWidth: 200,
           color: 'white',
           textAlign: 'center',
           padding: '15px',
           fontWeight: '250',
           fontSize : '18px',
           height: 'auto',
           alignContent: 'center',               
        },
        FondoTable :{
       
            backgroundColor: theme.palette.greyFondo.main
        },
        containerTable: {
            maxHeight: 440,
            maxWidth: '100%'
        },
        modalPdf: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
          },
          paperPdf: {
            backgroundColor: theme.palette.background.paper,
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
            width: '50%',
          },
    }));
const formatterPeso = new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP'
})
const TblPropiedadesModal = () => {
    const { DatodetallePropBienesModal } = useContext(UserContext);

    const [OpenModalpdfPropiedades, setOpenModalpdfPropiedades] = React.useState(false); 

    const handleClickOpenpdf =()=>{
        setOpenModalpdfPropiedades(!OpenModalpdfPropiedades); 
    }

    const CloseModalPdf =()=>{
        setOpenModalpdfPropiedades(false); 
    }
  
    const classes = useStyles();
    
    return (
        <div>



             {/*MODAL PDF INFORME COMER*/}

  <Modal
    aria-labelledby="transition-modal-title"
    aria-describedby="transition-modal-description"
    className={classes.modalPdf}
    open={OpenModalpdfPropiedades}
    onClose={CloseModalPdf}
    closeAfterTransition
    BackdropComponent={Backdrop}
    BackdropProps={{
      timeout: 2000,
    }}>
    <Fade in={OpenModalpdfPropiedades}>
    
      <div className={classes.paperPdf}>


        <IcpdfPropiedadesModal  />      

 
      
      </div>
 
    </Fade> 
    </Modal>


              
             <h4 className={classes.tituloTable}>Propiedades y Bienes</h4>
             
            { DatodetallePropBienesModal && DatodetallePropBienesModal==='ERROR CONSULTA PROPIEDADES' ? 'Error al procesar su solicitud, inténtelo mas tarde' : ''}

            <br />
            { DatodetallePropBienesModal && DatodetallePropBienesModal.DetallePropiedadesYBienes!=null ? <div style={{alignContent:"center", textAlign : "center"}}><Button variant="contained" color="primary" onClick={handleClickOpenpdf}>Descargar PDF</Button></div> : ''}

           <br />   

            { DatodetallePropBienesModal && DatodetallePropBienesModal.DetallePropiedadesYBienes==null ? <h2>Cargando información...</h2> : 
          
            

        <Grid container  direction="row" justify="space-between" alignItems="center"  >

        <Grid item xs={12} sm={12} xl={12} md={12} lg={12}>
        
            <TableContainer className={classes.containerTable}>
            <Table>
            <TableHead className={classes.FondoTable}>
                <TableRow   >
                    <TableCell>#</TableCell>
                    <TableCell>Destino</TableCell>
                    <TableCell>Rol</TableCell>
                    <TableCell>Dirección</TableCell>
                    <TableCell>Comuna</TableCell>
                    <TableCell>Ciudad</TableCell>
                    <TableCell>Serie</TableCell>
                    <TableCell>Avaluo</TableCell>

                
                </TableRow>
            </TableHead>
            <TableBody>
             {DatodetallePropBienesModal && DatodetallePropBienesModal.DetallePropiedadesYBienes?.map((datapro, idpropiedad)=>(
              <TableRow  key={idpropiedad+1}>
              <TableCell>{idpropiedad+1}</TableCell>
              <TableCell>{datapro.Rol}</TableCell>
              <TableCell>{datapro.Destino}</TableCell>
              <TableCell>{datapro.Direccion}</TableCell>
              <TableCell>{datapro.Comuna}</TableCell>
              <TableCell>{datapro.Ciudad}</TableCell>
              <TableCell>{datapro.Serie}</TableCell>
              <TableCell align="right" >$ {datapro.Avaluo}  </TableCell>

             
             </TableRow>
             ))}
              </TableBody>
            
             
            </Table>
            
    
        </TableContainer>
        </Grid>      
                 
        <Grid item xs={12} sm={12} xl={6} md={6} lg={6}></Grid>
         <Grid item xs={12} sm={12} xl={6} md={6} lg={6}>
        
        <Table align="right" size="small">
                    <TableHead className={classes.FondoTable}>
                        
                        <TableRow>
                      
                            <TableCell align="right">Cantidad de Propiedades y Bienes: { DatodetallePropBienesModal && DatodetallePropBienesModal?.NumeroPropiedades}</TableCell>
                          
                            
                        </TableRow>
                        <TableRow>
                    
                            <TableCell align="right">Total Avalúo: {formatterPeso.format( DatodetallePropBienesModal && DatodetallePropBienesModal?.MontoTotalAvaluo)}</TableCell>
                            
                        </TableRow>
                        
                        
                    </TableHead>
        </Table>
     </Grid>
    </Grid>
      }

        </div>
    )
}

export default TblPropiedadesModal;
